import { render, staticRenderFns } from "./subGroup.vue?vue&type=template&id=4f0fe073&scoped=true"
import script from "./subGroup.vue?vue&type=script&lang=js"
export * from "./subGroup.vue?vue&type=script&lang=js"
import style0 from "./subGroup.vue?vue&type=style&index=0&id=4f0fe073&prod&lang=scss"
import style1 from "./subGroup.vue?vue&type=style&index=1&id=4f0fe073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0fe073",
  null
  
)

export default component.exports